module.exports = __webpack_public_path__ + "media/images/sample/goldmuenzen-mozart_dollar-1oz-vs-149f8745aac883851020832ad19af7d4.jpg";